import { mergeMap, tap } from 'rxjs/operators';
// RxJS
import { delay, distinctUntilChanged, skip, filter, take, map } from 'rxjs/operators';
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../../_base/crud';
// State
import { AppState } from '../../../reducers';
import { selectProductsInStore, selectProductsPageLoading, selectProductsShowInitWaitingMessage } from '../_selectors/product.selectors';


export class ProductsDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();

		this.loading$ = this.store.pipe(
			select(selectProductsPageLoading),
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectProductsShowInitWaitingMessage)
		);

		this.store.pipe(
			select(selectProductsInStore),
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});
	}
}